import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { disabledStyle } from "../../../Common/ClickDisable";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { useDispatch } from "react-redux";
import { addSell, updateSell } from "../../../../redux/sale/action";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { Commas } from "../../../Common/AllDateTimeReleventFormate";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import DownloadButton from "../../../Common/FilesRelevent/DownloadButton";
import ActiveHTMLDescription from "../../../Common/CustomeLabel/ReactQuill/ActiveHTMLDescription";

const bxpDatatomap = [
  { title: "Price in $", name: "price", placeholder: "Enter total cost" },
];

const PricingTerms = ({
  updateindex,
  bxpData,
  setActiveTab,
  setModalOpen,
  setModal,
}) => {
  const [loading, setLoading] = useState(null);
  const dispatch = useDispatch();

  const initialValues = {
    price: bxpData?.price || "",
    payment_type: bxpData?.payment_type || 2,
    terms: bxpData?.terms || "",
    milestones: bxpData?.milestones || [
      {
        title: "",
        duration: "",
        amount: "",
      },
    ],
  };

  const validationSchema = Yup.object().shape({
    price: Yup.string().required("Price is required"),
    payment_type: Yup.string().required("Payment terms are required"),
    terms: Yup.string(),
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const updatedBxpData = {
        ...bxpData,
        price: values.price,
        payment_type: values.payment_type,
        terms: values.terms,
        milestones: values.milestones,
      };

      if (updateindex !== null) {
        dispatch(updateSell(updatedBxpData, setLoading));
      } else {
        dispatch(addSell(updatedBxpData, setLoading));
        localStorage.removeItem("BSM_ADD_DRAFT");
      }

      setModalOpen(false);
      setModal(false);
    } catch (error) {
      console.error("Error submitting BXP:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  console.log(bxpData, 'bxpData');

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              {bxpDatatomap.map((prop, key) => {
                return (
                  <div className="d-flex price-flex flex-column">
                    <div className="price-duration">
                      <h6>Item Title</h6>
                      <h4>{bxpData?.title}</h4>
                    </div>
                    <div className="price-duration">
                      <h6>Industry</h6>
                      <h4>{bxpData?.industry_index?.label || bxpData?.industry_title}</h4>
                    </div>
                    <div className="price-duration">
                      <h6>Category</h6>
                      <h4>{bxpData?.category_index?.label || bxpData?.category_title}</h4>
                    </div>
                    {bxpData?.sub_category_title && <div className="price-duration">
                      <h6>Sub-Category</h6>
                      <h4>{bxpData?.sub_category_title}</h4>
                    </div>}
                    <div className="price-duration">
                      <h6>Product price</h6>
                      <h4>$ {Commas(bxpData?.price)}</h4>
                    </div>
                    <div className="price-duration">
                      <h6>Description</h6>
                      <ActiveHTMLDescription
                        value={bxpData?.description}
                      />
                    </div>
                    <div className="price-duration">
                      <h6>Item’s images</h6>
                      <>
                        {Array.isArray(bxpData?.files) &&
                          bxpData?.files
                            .filter((item) => item.status != 3)
                            .map((item, index) => (
                              <div
                                key={index}
                                className="image-container mb-0 col-md-5 p-0 mb-3"
                              >
                                <DisplayFileProper item={item} />
                                <DownloadButton file={item} />
                              </div>
                            ))}
                      </>
                    </div>
                    <div className="price-duration">
                      <h6>Country</h6>
                      <h4>{bxpData?.country_title}</h4>
                    </div>
                    <div className="price-duration">
                      <h6>Product condition</h6>
                      <h4>
                        {bxpData?.product_condition == 2 ? "Used" : "Brand New"}
                      </h4>
                    </div>
                    <div className="price-duration">
                      <h6>Shipping charges</h6>
                      <h4>
                        {bxpData?.shipping == 2 ? "Not Included" : "Included"}
                      </h4>
                    </div>
                  </div>
                );
              })}
              <div className="button-container">
                <p
                  style={loading ? disabledStyle : {}}
                  className="prev-button w-100"
                  onClick={() => setActiveTab("WorkSamples")}
                >
                  Back
                </p>
                <button className="next-button w-100" type="submit">
                  {loading ? (
                    <LoginLoaderButton />
                  ) : updateindex !== null ? (
                    "Save and Publish"
                  ) : (
                    "Add and Publish"
                  )}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PricingTerms;
